import { IError, IQueryHookOptions } from '@comptia-sso/core';
import { UseMutateAsyncFunction, useMutation } from 'react-query';

// Services.
import { sendConsent } from 'services';

import { ISendConsentRequest, ISendConsentResponse } from 'types';

type SendConsentFunction = UseMutateAsyncFunction<
  ISendConsentResponse,
  IError,
  ISendConsentRequest
>;

type UseSendConsent = [SendConsentFunction, IQueryHookOptions];

export const useSendConsent = (id = ''): UseSendConsent => {
  const { error, isError, isLoading, mutateAsync } = useMutation<
    ISendConsentResponse,
    IError,
    ISendConsentRequest
  >((values: ISendConsentRequest) => sendConsent(id, values));

  return [mutateAsync, { error, isError, isLoading }];
};
